export default __webpack_public_path__ + "static/media/79t.cfbc0b16.jpg";